// 处理请求字段

export default {
  methods: {
    // 处理过滤字段
    handleFilters(data) {
      const minArr = [];
      const maxArr = [];
      for (let key in data) {
        const { min, max } = data[key];
        if (min) minArr.push(min);
        if (max) maxArr.push(max);
      }
      return [minArr.join(','), maxArr.join(',')];
    },

    // 将维度转换为其指定的值
    handleDimensions() {
      const temp = this.dimension.reduce((prev, current) => {
        if (current === 'date') {
          prev.push(this.date);
        } else {
          prev.push(current);
        }
        return prev;
      }, []);
      return temp.join(',');
    },

    handleDimensionsChart() {
      const temp = ['date'].reduce((prev, current) => {
        if (current === 'date') {
          prev.push(this.date);
        } else {
          prev.push(current);
        }
        return prev;
      }, []);
      return temp.join(',');
    },

    // 处理大区渠道销售信息，适配 el-cascader 的结构
    handleRegions(ori = []) {
      let formatted = [];
      ori.forEach(i => {
        let area = {}; // 大区信息
        area.value = i.department_id;
        area.label = i.department_name;
        if (i.department_sub && i.department_sub.length > 0) {
          let child = [];
          i.department_sub.forEach(s => {
            let channel = {}; // 渠道销售信息
            channel.value = s.id;
            channel.label = s.name;
            child.push(channel);
          });
          area.children = child;
        }
        formatted.push(area);
      });
      formatted.unshift({
        value: '',
        label: '全部'
      });
      return formatted;
    }
  }
};
